import { Component } from '@angular/core';
import { ProductScrollComponent } from '@spartacus/storefront';

@Component({
  selector: 'cx-product-scroll',
  templateUrl: './product-scroll.component.html',
  styleUrl: './product-scroll.component.scss',
  standalone: false,
})
export class CustomProductScrollComponent extends ProductScrollComponent {}
